
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ArrowPhotoOverlayIcon extends Vue {}
